import storage from '../common/utils/storage'
import { isEmpty } from 'lodash'

const userKey = 'user'
const tokenKey = 'token'

export function tryGetAuthInfo() {
    try {
        const user = storage.getValue(userKey, Object)
        const token = storage.getValue(tokenKey, Object)
        return !(isEmpty(user) && isEmpty(token)) ? { user, token } : null
    } catch (ex) {
        return null
    }
}

export function storeAuthInfo({ user, token }) {
    localStorage.setItem(userKey, JSON.stringify(user))
    localStorage.setItem(tokenKey, JSON.stringify(token))
}

export function cleanAuthInfo() {
    localStorage.removeItem(userKey)
    localStorage.removeItem(tokenKey)
}
